import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ProgrammableLogicController_ShellService } from './ProgrammableLogicController.shell.service';
import { ProgrammableLogicController_OperationService } from './ProgrammableLogicController.operation.service';
import { ProgrammableLogicController_DatasourceService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_FlowService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_FrontendFlowService } from './ProgrammableLogicController.frontend.flow.service';
import { ProgrammableLogicController_ReportService } from './ProgrammableLogicController.report.index';
import { ProgrammableLogicController_LocalizationService } from './ProgrammableLogicController.localization.service';
import { ProgrammableLogicController_configuration_form_ComponentContextService } from './ProgrammableLogicController.configuration_form.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ProgrammableLogicController.frontend.types'
import { $frontendTypes as $types} from './ProgrammableLogicController.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ProgrammableLogicController_warehouses_dd_singleComponent } from './ProgrammableLogicController.warehouses_dd_single.component'
import { ProgrammableLogicController_projects_dd_singleComponent } from './ProgrammableLogicController.projects_dd_single.component'
import { ProgrammableLogicController_connector_settings_singleComponent } from './ProgrammableLogicController.connector_settings_single.component'
import { ProgrammableLogicController_plc_type_dd_singleComponent } from './ProgrammableLogicController.plc_type_dd_single.component'
import { ProgrammableLogicController_orderclasses_dd_singleComponent } from './ProgrammableLogicController.orderclasses_dd_single.component'

@Component({
  imports: [
    SharedModule,
    forwardRef(() => ProgrammableLogicController_warehouses_dd_singleComponent),
    forwardRef(() => ProgrammableLogicController_projects_dd_singleComponent),
    forwardRef(() => ProgrammableLogicController_connector_settings_singleComponent),
    forwardRef(() => ProgrammableLogicController_plc_type_dd_singleComponent),
    forwardRef(() => ProgrammableLogicController_orderclasses_dd_singleComponent),
  ],
  selector: 'ProgrammableLogicController-configuration_form',
  templateUrl: './ProgrammableLogicController.configuration_form.component.html'
})
export class ProgrammableLogicController_configuration_formComponent extends BaseComponent implements OnInit, OnDestroy {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  outParams: { warehouse?: number, project?: number, connector_name?: string, connector_type?: string, order_class?: number } = { warehouse: null, project: null, connector_name: null, connector_type: null, order_class: null };
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ warehouse?: number, project?: number, connector_name?: string, connector_type?: string, order_class?: number }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  formGroup: FormGroup = new FormGroup({
    warehouse: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    connector_name: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    plc_type: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    order_class: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
      confirm: new ToolModel(new ButtonModel('confirm', new ButtonStyles(['primary'], null), false, false, false, 'Confirm', '', null)
    , false),
      cancel_button: new ToolModel(new ButtonModel('cancel_button', new ButtonStyles(['destructive'], null), false, false, false, 'Cancel', '', null)
    , false)
  };

  fields = {
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouse', true, false),
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', true, false),
    connector_name: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['connector_name'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Connector name', true, false),
    plc_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['plc_type'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Connector type', true, false),
    order_class: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['order_class'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Order class', false, false),
  };

  fieldsets = {
    Configuration: new FieldsetModel(
      'configurations',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    warehouse: this.fields.warehouse.control.valueChanges
    ,
    project: this.fields.project.control.valueChanges
    ,
    connector_name: this.fields.connector_name.control.valueChanges
    ,
    plc_type: this.fields.plc_type.control.valueChanges
    ,
    order_class: this.fields.order_class.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ProgrammableLogicController_ShellService,
private $datasources: ProgrammableLogicController_DatasourceService,
private $flows: ProgrammableLogicController_FlowService,
private $frontendFlows: ProgrammableLogicController_FrontendFlowService,
private $reports: ProgrammableLogicController_ReportService,
private $localization: ProgrammableLogicController_LocalizationService,
private $operations: ProgrammableLogicController_OperationService,
private $logger: CleanupLoggerService,
private $context: ProgrammableLogicController_configuration_form_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'New configuration';
  
    const $form = this;
    const $utils = this.$utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .warehouse
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .project
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .connector_name
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .plc_type
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .order_class
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $form: ProgrammableLogicController_configuration_formComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_configuration_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'configuration_form.on_init');
  
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $form: ProgrammableLogicController_configuration_formComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_configuration_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'configuration_form.on_cancel_clicked');
  $form.close();
  }
  on_confirm_clicked(event = null) {
    return this.on_confirm_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_confirm_clickedInternal(
    $form: ProgrammableLogicController_configuration_formComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_configuration_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'configuration_form.on_confirm_clicked');
  //$form.outParams.bot_type = $form.fields.bot_type.control.value
  $form.outParams.order_class = $form.fields.order_class.control.value
  $form.outParams.connector_name = $form.fields.connector_name.control.value
  $form.outParams.connector_type = $form.fields.plc_type.control.value
  $form.outParams.warehouse = $form.fields.warehouse.control.value
  $form.outParams.project = $form.fields.project.control.value
  
  $form.close();
  }
  //#endregion private flows
}
